<template>
  <div :class="['rounded-md p-4',
                hasBorder ? 'border' : '',
                type === 'success' ? 'border-green-200 bg-green-50 [&>a]:text-green-600 [&>a]:hover:text-green-800' : '',
                type === 'info' ? 'border-blue-200 bg-blue-50 [&>a]:text-blue-600 [&>a]:hover:text-blue-800' : '',
                type === 'warning' || type === 'danger' ? 'border-yellow-200 bg-yellow-50 [&>a]:text-yellow-600 [&>a]:hover:text-yellow-800' : '']">
    <div class="flex">
      <div class="flex-shrink-0">
        <CheckCircleIcon v-if="type === 'success'" class="h-6 w-6 text-green-400" aria-hidden="true" />
        <InformationCircleIcon v-else-if="type === 'info'" class="h-6 w-6 text-blue-400" aria-hidden="true" />
        <ExclamationTriangleIcon v-else-if="type === 'warning' || type === 'danger'" class="h-6 w-6 text-yellow-400" aria-hidden="true" />
      </div>
      <div class="ml-3">
        <p :class="[type === 'success' ? 'text-green-800' : '',
                    type === 'info' ? 'text-blue-700' : '',
                    type === 'warning' || type === 'danger' ? 'text-yellow-700' : '']"
        ><slot /></p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { CheckCircleIcon, ExclamationTriangleIcon, InformationCircleIcon } from '@heroicons/vue/20/solid';

type AlertType = 'success' | 'info' | 'warning' | 'danger'

defineProps({
  type: {
    type: String as PropType<AlertType>,
    default: 'warning',
  },
  hasBorder: {
    type: Boolean,
    default: false,
  },
});
</script>
